define(["dojo/i18n", "/local/buildagent/work/7bfdef0d49469377/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js"
,"nls/ja-jp/mldoStringResource"
,"nls/ko-kr/mldoStringResource"
,"nls/zh-cn/mldoStringResource"
,"/local/buildagent/work/7bfdef0d49469377/assets/js/nls/mldoStringResource.js?absMid=nls/mldoStringResource"
], function(loader, runner) {
   return runner(loader, "nls/mldoStringResource", __webpack_require__.dj.c(), true);
});